/* eslint-disable no-unused-vars */
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes, { object } from 'prop-types';
import { Box, Button, IconButton, Tooltip, TextField } from '@mui/material';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { ReactComponent as RestoreIcon } from 'src/assets/icons/restore.svg';
import { ReactComponent as TrashIcon } from 'src/assets/icons/lineTrash.svg';
import { ReactComponent as GoBackIcon } from 'src/assets/icons/goBack.svg';

export default function LixeiraTable({
  allData,
  colunas,
  restoreFunction,
  setLixeiraData,
  OnClose,
  titulo,
}) {
  const data = useMemo(() => {
    if (!Array.isArray(allData) || allData.length === 0) return [];

    return allData.map((item) => {
      if (item[titulo] && typeof item[titulo] === 'object') {
        return { ...item[titulo] }; // Retorna diretamente os valores dentro
      }
      return {}; // Retorna um objeto vazio
    });
  }, [allData]);

  const columns = useMemo(() => {
    if (!colunas || typeof colunas !== 'object') return [];

    const excludeKeys = [
      'titulo',
      'endpoint',
      'relatorios',
      'acoes',
      'repete',
      'downloadupload',
      'gridsalvar',
      'griddeletar',
      'rateio',
      'rateiovalor',
      'corfundo',
    ];

    return Object.entries(colunas)
      .filter(([key, _]) => !excludeKeys.includes(key))
      .map(([key, item]) => ({
        accessorKey: key,
        header: item?.nome || key,
      }));
  }, [colunas]);

  const lixeira = useMaterialReactTable({
    columns,
    data,
    initialState: { showGlobalFilter: false, density: 'compact' },

    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableEditing: true,
    enableSorting: false,
    enableGlobalFilter: false,
    enableColumnFilter: false,
    enableColumnActions: false,

    muiToolbarAlertBannerProps: {
      sx: {
        backgroundColor: 'transparent',
        color: '#146b7c',
      },
    },

    muiTableContainerProps: {
      sx: { height: '100%', width: '100%' },
    },

    muiTablePaperProps: {
      sx: {
        boxShadow: 'none',
      },
    },

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Deletar">
          <IconButton onClick={() => HandleDelete(row)}>
            <RestoreIcon className="tableIcon line" />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    localization: MRT_Localization_PT_BR,
  });

  function HandleDelete(row) {
    const extractedLine = Object.entries(allData)
      .filter(([key]) => parseFloat(key) === row.index)
      .map(([_, item]) => item);

    const theRest = Object.entries(allData)
      .filter(([key]) => parseFloat(key) !== row.index)
      .map(([_, item]) => item);

    setLixeiraData(theRest);

    restoreFunction(extractedLine);
  }

  return (
    <div className="lixeira">
      <button onClick={OnClose} className="exit red">
        <GoBackIcon />
      </button>

      <span className="title red">
        <h2>
          <TrashIcon /> Lixeira
          <hr />
        </h2>
        <div />
      </span>

      <Box
        sx={{
          display: 'flex',
          position: 'relative',
          width: '100%',
          height: '100%',
        }}
      >
        <MaterialReactTable table={lixeira} />
      </Box>
    </div>
  );
}

LixeiraTable.propTypes = {
  allData: PropTypes.array,
  colunas: PropTypes.object,
  restoreFunction: PropTypes.func,
  setLixeiraData: PropTypes.func,
  OnClose: PropTypes.func,
  titulo: PropTypes.string,
};
